export default __webpack_public_path__ + "static/onboarding2-ecfc0900e9900af68c79d7b1f6083610.webp";